<template>
  <div class="info-region-container">
    <div class="all-content-container">
      <div class="container1">
        <div class="titlemaun">
          <div class="div-h3">
            <h3>绑定摄像头</h3>
          </div>

        </div>
        <div class="div-step">
          <el-steps :active="4" align-center>
            <el-step title="添加决策模型"></el-step>
            <el-step title="关联摄像头"></el-step>
            <el-step title="关联生长模型"></el-step>
            <el-step title="绑定城市"></el-step>
            <el-step title="绑定摄像头"></el-step>
            <el-step title="添加设备调控"></el-step>
            <el-step title="添加大棚告警"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="container1">
        <div class="info-content-container">
          <div class="table_content1" style="margin-top: 10px">
            <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="摄像头：" prop="deviceId">
                    <el-select v-model="ruleForm.deviceId" placeholder="请选择摄像头" clearable>
                      <el-option v-for="item in videoArray" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="display: flex;justify-content: space-around;">
              <div></div>
              <div class="pagination-container" style="margin-left: 12rem;">
                <div class="page"></div>
                <div slot="footer" class="div-footer">
                  <el-button type="primary" @click="handleSave">保 存</el-button>
                </div>
              </div>

              <div style="margin-top: 1.2rem;">
                <el-button type="primary" @click="handlePrev">上一步</el-button>
                <el-button type="primary" @click="handleNext">下一步</el-button>
                <el-button type="primary" @click="handleReturn">返回决策模型</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        // 添加编辑弹窗表单字段
        decisionId: "",
        groupId: "",
        deviceId: "",
      },
      rules: {
        // 添加编辑弹窗表单规则
        deviceId: [
          {
            required: true,
            message: "请选择摄像头",
            trigger: "change",
          },
        ],
      },
      videoArray: [], // 大棚名称数组
    };
  },
  created() {
    this.ruleForm.decisionId = this.$route.query.decisionId;

    // 获取详情
    this.getDetail();
  },
  methods: {
    // 获取详情
    getDetail() {
      if (!this.ruleForm.decisionId || this.ruleForm.decisionId == "") {
        return;
      }

      this.$api.growthModel
        .getGrowthModelDecision({ id: this.ruleForm.decisionId })
        .then((res) => {
          if (res.code == 200) {
            this.ruleForm.deviceId = res.data.deviceId;
            this.ruleForm.groupId = res.data.groupId;

            // 获取摄像头列表
            this.getVideoList();
          }
        });
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.growthModel.bandingVideo(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
            }
          });
        }
      });
    },
    // 获取摄像头列表
    getVideoList() {
      if (!this.ruleForm.groupId || this.ruleForm.groupId == "") {
        return;
      }

      this.$api.device
        .getVideosByGroupId({ id: this.ruleForm.groupId })
        .then((res) => {
          if (res.code == 200) {
            this.videoArray = res.data;
          }
        });
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `decisionManagement`,
        query: {},
      });
    },
    // 上一步
    handlePrev() {
      this.$router.push({
        name: `bandingCity`,
        query: {
          decisionId: this.$route.query.decisionId,
          groupId: this.$route.query.groupId,
        },
      });
    },
    // 下一步
    handleNext() {
      this.$router.push({
        name: `addDeviceControl`,
        query: {
          decisionId: this.$route.query.decisionId,
          groupId: this.$route.query.groupId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.all-content-container {
  margin: 0 auto;
  width: 100%;
  margin-top: 10px;

  .container1 {
    border: 1px solid rgba(232, 232, 232, 1);
    margin-top: 10px;
  }

  .div-h3 {
    padding: 15px;
  }

  .div-button {
    margin-top: 10px;
    margin-right: 10px;
  }

  .div-step {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .div-footer {
    text-align: center;
    margin-bottom: 50px;
  }

  .titlemaun {
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid #ededed;
  }
}

.demo-ruleForm {
  width: 600px;
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 30px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }

  .add-more {
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    color: #256bff;
    cursor: pointer;
  }
}
</style>